export const environment = {
	env: 'live',
	production: true,
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	urls: {
		api: {
			auth: 'https://finbase-api.staging.arth.bz',
			base: 'https://athos-api.staging.arth.bz/',
			sdk_api: 'https://sdk-api.staging.arth.bz/',
			sdk: 'https://www.sdk.staging.arth.bz/',
			user: 'https://gbp7uj3hz7.execute-api.ap-south-1.amazonaws.com/Prod/',
			old_url: 'https://athos-api.staging.arth.bz/',
			ice_url: 'https://ice-api.staging.arth.bz/',
			ovs_url: 'https://ovs-api.staging.arth.bz/',
			lms_url: 'https://lms-api.staging.arth.bz/v1/',
			los_url: 'https://api.arth.staging.bz/'
			//lms_url:'http://localhost:7100/v1/'
		},
		elastic: {
			bypass_es_auth: false,
			model_suffix: '',
			lambda: 'https://775ikug2g4.execute-api.ap-south-1.amazonaws.com/Prod/',
			base: 'https://search-arthapp-stage-elasticsearch-ythmn3ziltgjwt3gkztg7eivae.ap-south-1.es.amazonaws.com/',
			auth: 'https://finbase-api.staging.arth.bz',
			indices: {
				product_versions: 'production_product_versions',
				product_commercials: 'production_product_commercials',
				product_credits: 'production_product_credits',
				tncs: 'production_product_tncs',
				product_details: 'production_product_details',
				product_fldgs: 'production_product_fldgs',
				partners: 'production_partners',
				lenders: 'production_lenders',
				bank_accounts: 'production_bank_accounts',
				disbursal_limits: 'production_disbursal_limits', // from API
				product_mappings: 'production_product_mappings',
				customers: 'production_customers',
				loans: 'production_loans',
				loan_requests: 'production_leads',
				spocs: 'production_spocs',
				partner_file_uploads: 'production_partner_file_uploads',
				prequalifications: 'production_customer_pre_qualifications',
				repayments: 'production_loan_repays',
				ace_configs: 'production_product_ace_configs',
				crif_data_requests: 'production_crif_reports',
				ace_algos: 'production_product_ace_algos',
				lender_mappings: 'lender_mappings_production',
				crif_data: 'production_crif_reports',
				ckyc_data: 'ckyc_reports',
				bank_transactions: 'production_bank_transactions',
				loan_monthly_interests: 'production_loan_monthly_interests',
				file_uploads: 'production_file_uploads',
				payment_advices: 'production_payment_advices',
				cohorts: 'production_cohorts'
			}
		}
	}
};
